import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Avatar,
  Paper,
  TableContainer,
} from "@mui/material";
import {
  Edit as EditIcon,
  Block as BlockIcon,
  Delete as DeleteIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import { CoOwner } from "../../../validation/business.validation";
import ConfirmDeleteDialog from "../../../common/confirmDeleteAlert";
import ConfirmBlockDialog from "../../../common/confirmBlockAlert";
import { formatPhoneNumber } from "../../../helper/phoneFormatter.helper";

interface Props {
  coOwners: CoOwner[];
  onDelete: (emp: CoOwner) => void;
  onEdit: (emp: CoOwner) => void;
  onBlock: (emp: CoOwner) => void;
}

const CoOwnerTableView: React.FC<Props> = ({
  coOwners,
  onDelete,
  onEdit,
  onBlock,
}) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openStatusDialog, setOpenStatusDialog] = React.useState(false);
  const [selectedCoOwner, setSelectedCoOwner] = React.useState<CoOwner | null>(
    null
  );

  const handleOpenDialog = (coOwner: CoOwner) => {
    setSelectedCoOwner(coOwner);
    setOpenDialog(true);
  };

  const handleDelete = () => {
    if (selectedCoOwner) {
      onDelete(selectedCoOwner);
    }
    setOpenDialog(false);
    setSelectedCoOwner(null);
  };

  const handleEdit = (coOwner: CoOwner) => {
    onEdit(coOwner);
  };

  const openDeactivateDialog = (coOwner: CoOwner) => {
    setSelectedCoOwner(coOwner);
    setOpenStatusDialog(true);
  };

  const handleStatusConfirm = () => {
    if (selectedCoOwner) {
      onBlock(selectedCoOwner);
    }
    setOpenStatusDialog(false);
    setSelectedCoOwner(null);
  };
  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: 3}}>
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f9fafb" }}>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Phone
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  border: "1px solid #e5e7eb",
                  textAlign: "center",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {coOwners.map((coOwner, index) => (
              <TableRow
                key={index}
                hover
                className={coOwner.isActive === false ? "bg-gray-100" : ""}
              >
                <TableCell
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "#f3f4f6",
                      color: "#6b7280",
                      width: 32,
                      height: 32,
                    }}
                  >
                    <PersonIcon fontSize="small" />
                  </Avatar>
                  {`${(coOwner as any).firstName || ''} ${(coOwner as any).middleName || ''} ${(coOwner as any).lastName || ''}`.trim() || (coOwner as any).name || "-"}
                </TableCell>
                <TableCell sx={{ border: "1px solid #e5e7eb" }}>
                  {coOwner.email || "-"}
                </TableCell>
                <TableCell sx={{ border: "1px solid #e5e7eb" }}>
                  {coOwner.phone ? formatPhoneNumber(coOwner.phone) : "-"}
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid #e5e7eb",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 4,
                    }}
                  >
                    <Tooltip title="Edit">
                      <IconButton
                        color="secondary"
                        size="small"
                        onClick={() => handleEdit(coOwner)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Deactivate">
                      <IconButton
                        size="small"
                        sx={{ color: "#f59e0b" }}
                        onClick={() => openDeactivateDialog(coOwner)}
                      >
                        <BlockIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleOpenDialog(coOwner)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmDeleteDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleDelete}
        itemName={selectedCoOwner?.name || ""}
      />

      <ConfirmBlockDialog
        open={openStatusDialog}
        isActive={!!selectedCoOwner?.isActive}
        onClose={() => setOpenStatusDialog(false)}
        onConfirm={handleStatusConfirm}
        itemName={selectedCoOwner?.name}
      />
    </>
  );
};

export default CoOwnerTableView;
